var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefliesLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94 17.7H5.6C3.61 17.7 2 16.09 2 14.1V5.6C2 3.62 3.61 2 5.6 2H14.1C16.08 2 17.7 3.61 17.7 5.6V8.94C17.7 9.27 17.43 9.54 17.1 9.54C16.77 9.54 16.5 9.27 16.5 8.94V5.6C16.5 4.28 15.42 3.2 14.1 3.2H5.6C4.28 3.2 3.2 4.28 3.2 5.6V14.1C3.2 15.42 4.28 16.5 5.6 16.5H8.94C9.27 16.5 9.54 16.77 9.54 17.1C9.54 17.43 9.27 17.7 8.94 17.7Z",
    fill: "#717274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.004 12C17.2785 12.0006 17.5006 12.2266 17.5 12.505L17.494 15.4971C17.4935 15.7754 17.2705 16.0006 16.996 16C16.7215 15.9994 16.4994 15.7734 16.5 15.495L16.506 12.5029C16.5065 12.2246 16.7295 11.9994 17.004 12Z",
    fill: "#717274"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.004 12C15.2785 12.0006 15.5006 12.2266 15.5 12.505L15.494 15.4971C15.4935 15.7754 15.2705 16.0006 14.996 16C14.7215 15.9994 14.4994 15.7734 14.5 15.495L14.506 12.5029C14.5065 12.2246 14.7295 11.9994 15.004 12Z",
    fill: "#717274"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9652 10C13.2612 10.0007 13.5006 10.2847 13.5 10.6343L13.4881 17.3684C13.4875 17.7179 13.247 18.0007 12.951 18C12.655 17.9993 12.4156 17.7153 12.4162 17.3657L12.4281 10.6316C12.4287 10.2821 12.6692 9.99927 12.9652 10ZM11.0359 11.9416C11.3319 11.9416 11.5719 12.225 11.5719 12.5746V15.1063C11.5719 15.4558 11.3319 15.7392 11.0359 15.7392C10.74 15.7392 10.5 15.4558 10.5 15.1063V12.5746C10.5 12.225 10.74 11.9416 11.0359 11.9416Z",
    fill: "#717274"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefliesLogo);
export default __webpack_public_path__ + "static/media/fireflies_logo.b49a018bf9bee431a3a2fa5a18d516f9.svg";
export { ForwardRef as ReactComponent };